import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Amerikāņu futbols",
    Baseball: "Beisbols",
    Basketball: "Basketbols",
    Boxing: "Bokss",
    Chess: "Šahs",
    Cricket: "Krikets",
    Darts: "Šautriņu mešana",
    Entertainment: "Izklaide",
    "E-Sports": "E-Sports",
    Football: "Futbols",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Gēlu futbols",
    "Generic Sport": "Vispārējs sporta veids",
    Golf: "Golfs",
    "Greyhound Racing": "Suņu skriešana",
    Handball: "Rokasbumba",
    "Ice Hockey": "Hokejs",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politika",
    "Rugby League": "Regbija līga",
    "Rugby Union": "Regbija savienība",
    Snooker: "Snūkers",
    "Table Tennis": "Galda teniss",
    Tennis: "Teniss",
    "Virtual Football": "Virtuālais futbols",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} uzvarēt",
    WinFirstRound: "{name} uzvarēt pirmajā kārtā",
    FirstTouchdown: "{name} pirmajam gūt piezemējumu",
    FirstTry: "{name} censties gūt punktus pirmajam",
    TotalGoals: "{name} kopējie vārti",
    TotalRuns: "{name} kopējie skrējieni",
    TotalPoints: "{name} kopējie punkti",
    TopBatsman: "{name} būt top Batsmanam",
    TopBowler: "{name} būt top Bowlreim",
    FirstScore: "{name} pirmajam gūt vārtus"
  },
  PromoTexts: {
    Pick: "Izdariet savu izvēli",
    Bet: "Likme",
    Pays: "Izmaksa"
  },
  DateTimeTexts: {
    Today: "Šodien",
    Tomorrow: "Rīt",
    Live: "Live"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Izdariet savu izvēli",
    Return: "Izmaksa",
    Stake: "Likme",
    Draw: "X"
  },
  H2HTexts: {
    // general
    "Per match": "spēlē",
    H2H: "H2H",
    W: "U",
    D: "N",
    L: "Z",
    T: "N",

    // soccer
    goals_scored: "gūtie vārti",
    shots: "Sitieni",
    shots_on_target: "Sietieni Vārtos",
    ball_possession: "Bumbas kontrole",
    goals_conceded: "Zaudētie vārti",

    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
